/* eslint-disable max-len */
import { Button, Grid, Input } from '@mui/material';
import React, {
  ChangeEvent,
  useEffect, useMemo, useRef, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
// import * as XLSX from 'xlsx';
// import Papa from 'papaparse';
import dayjs from 'dayjs';
import html2pdf from 'html2pdf.js';
import DataTable from '../../Common/DataTable';
import ComponentDeleteModal from '../../Common/DeleteModal/ComponentDeleteModal';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
import { setLoader } from '../../redux/loaderSlice';
import { RootState } from '../../redux/rootState';
import { GetListingPayload } from '../../utils/type';
import {
  getOilReportsStart, uploadExcelStart, removeExcelDetails, deleteOilReportStart,
  resetState,
  getOilReportPdfDataStart,
  clearOilReportData,
  getExcelDataStart,
  resetEmailFlag,
} from './redux/oilReportSlice';
import { TableColumns } from './utils/constant';
import { DeleteOilReportPayload, OilReportData, UploadExcelPayload } from './utils/types';
import './style.scss';
import ComponentOilReportImportModal from './components/ImportOverview';
import OilReportPdfModal from '../../Common/OilReportPdfModal';
import ComponentOilReportEmailModal from '../../Common/OilReportEmailModal/ComponentOilReportEmailModal';
import { stripCustPrefix, waitForAllImagesToLoad } from '../../utils/CommonFunctions';
import { showErrorToaster } from '../../Common/ComponentToast/ComponentSuccessToasts';
import URLs from '../../Routes/EndPoints';
import { CheckedIcon, SelectedCheckBoxIcon } from '../../assets/TableIcons';
import DuplicacyConfirmationModal from './components/duplicacyConfirmationModal/DuplicacyConfirmationModal';
import {
  resetPagination, setPageNumber, setPageSize, setSearchParam,
  setSortColumn,
  setSortDirection,
} from '../taiReportingSystem/redux/sliceReportWorkspace';

export function OilReport() {
  // const [page, setPage] = useState(1);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [searchQuery, setSearchQuery] = useState('');
  const {
    pageNumber, pageSize, searchParam, sortColumn, sortDirection,
  } = useSelector((state: RootState) => state.reportWorkspaceReducer);
  const { historyStack } = useSelector((state:RootState) => state.masterDataReducer);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [printReport, setPrintReport] = useState(false);
  const [showOilReportEmailModal, setShowOilReportEmailModal] = useState(false);
  const [showOilReportReportModal, setShowOilReportReportModal] = useState(false);
  const [reportNumber, setReportNumber] = useState('');
  const [selectedId, setSelectedId] = useState('');
  const [openOilReportDuplicacyConfirmation, setOpenOilReportDuplicacyConfirmation] = useState(false);

  const navigate = useNavigate();
  const pdfRef = useRef(null);

  const {
    oilReportList, isLoading, isExcelDataFetched, selectedDocumentId,
    totalOilReports,
    oilReportPdfData, isFlagAdded,
  } = useSelector((state: RootState) => state.oilReportReducer);

  const dispatch = useDispatch();

  const btnRef = useRef<HTMLButtonElement>(null);

  const handleChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      // const baseName = file.name.substring(0, file.name.lastIndexOf('.'));

      // File format validation
      const allowedExtensions = ['csv', 'xlsx', 'xls'];
      if (!allowedExtensions.includes(fileExtension || '')) {
        showErrorToaster('Invalid file format. Please upload a CSV or Excel file (.csv, .xlsx, .xls).');
        return;
      }

      if (fileExtension === 'csv') {
        // const reader = new FileReader();

        // reader.onload = (e) => {
        //   const csvData = e.target?.result as string;

        //   Papa.parse(csvData, {
        //     header: true,
        //     complete: (result) => {
        //       const jsonData = result.data as Array<Record<string, string>>;

        //       const workbook = XLSX.utils.book_new();
        //       const worksheet = XLSX.utils.json_to_sheet(jsonData);
        //       XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        //       const binaryWorkbook = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        //       const newFile = new File([binaryWorkbook], `${baseName}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Trigger download
        // const blob = new Blob([binaryWorkbook], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        // const url = URL.createObjectURL(blob);
        // const link = document.createElement('a');
        // link.href = url;
        // link.download = `${baseName}.xlsx`;
        // link.click();
        // URL.revokeObjectURL(url);

        //       const payload: UploadExcelPayload = {
        //         file: newFile,
        //       };
        //       dispatch(uploadExcelStart(payload));
        //     },
        //   });
        // };

        // reader.readAsText(file);

        const payload: UploadExcelPayload = {
          file,
        };

        dispatch(uploadExcelStart(payload));
      } else if (fileExtension === 'xlsx' || fileExtension === 'xls') {
        const payload: UploadExcelPayload = {
          file,
        };

        dispatch(uploadExcelStart(payload));
      }
    }

    const inputElement = event.target as HTMLInputElement;
    inputElement.value = ''; // Reset input
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleData = () => {
    const payload: GetListingPayload = {
      page: pageNumber,
      rowsPerPage: pageSize,
      searchQuery: searchParam,
      sortCol: sortColumn,
      sortDir: sortDirection,
    };
    dispatch(getOilReportsStart(payload));
  };

  useEffect(() => {
    if (isFlagAdded) {
      handleData();
      dispatch(resetEmailFlag());
    }
  }, [isFlagAdded]);

  useEffect(
    () => (() => {
      dispatch(resetState());
    }),
    [],
  );

  useEffect(() => {
    if (selectedDocumentId?.DocumentId) {
      if (selectedDocumentId?.IsKitIdsExistInDb) {
        setOpenOilReportDuplicacyConfirmation(true);
      } else {
        dispatch(getExcelDataStart({
          documentId: selectedDocumentId?.DocumentId,
          searchQuery: '',
        }));
      }
    }
  }, [selectedDocumentId]);

  const handleCloseDupModal = () => {
    setOpenOilReportDuplicacyConfirmation(false);
    dispatch(clearOilReportData());
  };
  const handleConfirmDupModal = () => {
    setOpenOilReportDuplicacyConfirmation(false);
    dispatch(getExcelDataStart({
      documentId: selectedDocumentId?.DocumentId,
      searchQuery: '',
    }));
  };

  const data: OilReportData[] = useMemo(() => oilReportList
    .map((item, index) => {
      const transformedDataItem = {
        sn: index,
        isMailSent: item?.IsMailSent ? <CheckedIcon /> : <SelectedCheckBoxIcon />,
        action: 'edit&delete&sendMail&printPdf',
        reportNumber: item.ReportNumber,
        kitNumber: <span style={{ color: item?.IsFlaggedKit ? 'red' : 'black' }}>{item?.KitNumber}</span>,
        reportDate: item?.ReportDate ? dayjs(item.ReportDate).format('MM-DD-YYYY') : '',
        compSerialNumber:
  <span style={{ color: 'black' }}>
    {item?.CompSerialNumber}
    <span style={{ color: 'red', paddingLeft: '4px' }}>{(item?.CompSerialNumber?.trim()?.length > 0 && ((item.CompSerialNumber)?.match(/^ */)?.[0]?.length || 0) > 0) ? `(C${(item.CompSerialNumber?.match(/^ */)?.[0]?.length || 0) + 1})` : ''}</span>
  </span>,
        custId: stripCustPrefix(item.CustId),
        component: item?.Component,
        location: item.Location,
        serialNumber: item.SerialNumber,
        sampleNumber: item.SampleNumber,
        date: item.Date ? dayjs(item.Date).format('MM-DD-YYYY') : '',
        id: item.ReportNumber,
      };
      return transformedDataItem;
    }), [oilReportList]);

  const handleEdit = (reportId: string) => {
    navigate(`${reportId}`);
  };

  const handleButtonClick = () => {
    btnRef.current?.click();
  };

  const handlePrint = useReactToPrint({
    content: () => pdfRef.current,
    removeAfterPrint: true,
    copyStyles: true,
    documentTitle: `${oilReportPdfData?.PdfOtherDetails?.UnitSite?.replace(/[\r\n]+/g, ' ')?.trim() || ''}_${oilReportPdfData?.PdfOtherDetails?.KitNumber || ''}`,
  });

  const handleOilReportDelete = () => {
    const payload:DeleteOilReportPayload = {
      reportId: selectedId,
      page: pageNumber,
      rowsPerPage: pageSize,
      searchQuery: searchParam,
      sortCol: sortColumn,
      sortDir: sortDirection,
    };

    dispatch(deleteOilReportStart(payload));
    setShowDeleteModal(false);
  };

  const handleDelete = (id:string) => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };

  const handleOilReportEmailModal = (id: string) => {
    setReportNumber(id);
    setShowOilReportEmailModal(true);
  };

  const getCustomerId = useMemo(() => {
    const reportValues = oilReportList?.find((ele) => ele?.ReportNumber?.toString() === reportNumber?.toString());
    return reportValues?.CustId ?? '';
  }, [reportNumber]);

  const onOilReportModalClose = () => {
    setShowOilReportReportModal(false);
    dispatch(removeExcelDetails());
  };

  useEffect(() => {
    if (selectedDocumentId && isExcelDataFetched && !showOilReportReportModal) {
      setShowOilReportReportModal(true);
    }
  }, [isExcelDataFetched]);

  const handlePrintApi = (reportId: string) => {
    dispatch(getOilReportPdfDataStart(reportId));
    setPrintReport(true);
    dispatch(setLoader(true));
  };

  const handleDownloadPdf = async () => {
    const element = pdfRef.current;

    if (!element) return;

    try {
      // Wait for all images in the element to load
      await waitForAllImagesToLoad(element);

      const opt = {
        margin: 0,
        filename: 'report.pdf',
        image: { type: 'jpeg' as const, quality: 0.6 },
        html2canvas: {
          backgroundColor: null,
          useCORS: true,
          scale: 2,
          allowTaint: false,
        },
        jsPDF: {
          unit: 'mm' as const,
          format: 'letter' as const,
          orientation: 'landscape' as const,
          compress: true,
        },
      };

      const worker = html2pdf().set(opt).from(element);
      const pdfBlob = await worker.outputPdf('blob');

      const pdfFile = new File([pdfBlob], `${oilReportPdfData?.PdfOtherDetails?.UnitSite?.replace(/[\r\n]+/g, ' ')?.trim() || ''}_${oilReportPdfData?.PdfOtherDetails?.KitNumber || ''}.pdf`, { type: 'application/pdf' });
      // eslint-disable-next-line consistent-return
      return pdfFile;
    } catch (error) {
      // eslint-disable-next-line consistent-return
      return null;
    }
  };

  const onClickPreview = () => {
    handlePrint();
  };
  useEffect(() => {
    if (Object.keys(oilReportPdfData)?.length > 0 && printReport) {
      setTimeout(() => {
        onClickPreview();
        setPrintReport(false);
        dispatch(setLoader(false));
      }, 3000);
    }
  }, [oilReportPdfData, printReport]);

  useEffect(() => {
    handleData();
  }, [pageNumber, pageSize, searchParam, sortColumn, sortDirection]);

  useEffect(() => {
    if (historyStack) {
      const finderString = '/oil-report/';
      const last = historyStack[historyStack.length - 1];
      const sLast = historyStack[historyStack.length - 2];
      if (!(
        last?.includes(finderString)
            || (sLast?.includes(finderString) && last === '/oil-report')
      )) {
        dispatch(resetPagination());
      }
    }
  }, [historyStack]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <ComponentPageHeader subHeading="Oil Report" />
        </Grid>
        <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
          <div className="customTableWidth">
            <DataTable<OilReportData>
              handleButtonClick={handleButtonClick}
              data={data}
              columns={TableColumns}
              totalRecords={totalOilReports}
              buttonText="Import"
              buttonNameFifth="Flagged Kits"
              handleButtonClickFifth={() => { window.open(URLs.FLAGGED_KITS, '_blank', 'noopener,noreferrer'); }}
              page={pageNumber}
              setPage={(e) => { dispatch(setPageNumber(e)); }}
              rowsPerPage={pageSize}
              setRowsPerPage={(e) => { dispatch(setPageSize(e)); }}
              searchQuery={searchParam}
              setSearchQuery={(e) => { dispatch(setSearchParam(e)); dispatch(setPageNumber(1)); }}
              sortCol={sortColumn}
              setSortCol={(e) => { dispatch(setSortColumn(e)); dispatch(setPageNumber(1)); }}
              sortDir={sortDirection}
              setSortDir={(e) => { dispatch(setSortDirection(e)); dispatch(setPageNumber(1)); }}
              handleData={handleData}
              handleEdit={handleEdit}
              handleDelete={handleDelete}
              handleOilReportEmailModal={handleOilReportEmailModal}
              handlePrintPdf={handlePrintApi}
              minActionWidth="190px"
              handleDataFromComponent
            />
          </div>
        </Grid>
      </Grid>
      <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setShowDeleteModal(false)}
        handleDelete={handleOilReportDelete}
      />
      <ComponentOilReportImportModal
        show={showOilReportReportModal}
        setOpenFrom={onOilReportModalClose}
        rowsPerPage={pageSize}
        page={pageNumber}
        searchQuery={searchParam}
        sortCol={sortColumn}
        sortDir={sortDirection}
      />
      {getCustomerId && showOilReportEmailModal && (
        <ComponentOilReportEmailModal
          show={showOilReportEmailModal}
          setOpenFrom={() => setShowOilReportEmailModal(false)}
          onClickPreview={onClickPreview}
          customerId={getCustomerId}
          reportNumber={reportNumber ?? ''}
          downloadPdf={handleDownloadPdf}
        />
      )}
      <div style={{ display: 'none' }}>
        <div className="d-flex justify-content-center">
          <Input
            type="file"
            inputProps={{ accept: '.csv, .xlsx, .xls', style: { display: 'none' } }}
            id="fileInput"
            onChange={handleChange}
          />
          <label htmlFor="fileInput">
            <Button ref={btnRef} variant="contained" color="success" component="span">
              Import Excel File
            </Button>
          </label>
        </div>
      </div>

      <div style={{ visibility: 'hidden' }}>
        <OilReportPdfModal
          ref={pdfRef}
          oilReportPdfData={oilReportPdfData}
          show
        />
      </div>
      {openOilReportDuplicacyConfirmation && (
        <DuplicacyConfirmationModal
          show={openOilReportDuplicacyConfirmation}
          setOpenFrom={handleCloseDupModal}
          onConfirm={handleConfirmDupModal}
          data={selectedDocumentId}
        />
      )}
    </>
  );
}
